import React, { useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import { noimage } from "../../assets";
import moment from "moment";
import { GlobalContext } from "../../app/providers/GlobalState";
import InitialsAvatar from "../../shared/components/InitialsAvatar";

const Participante = ({ code, foto, nome, numero, professor, coordenador, ultimaEstado, perfil, substituto, match }) => {
    const globalContext = useContext(GlobalContext);

    const montarTitulo = (professor, coordenador, substituto) => {
        if (professor && coordenador) return <span className="perfil coordenador">Coord. / Prof.</span>;
        else if (coordenador) return <span className="perfil coordenador">Coordenador</span>;
        else if (professor && substituto) return <span className="perfil professor substituto">Professor Substituto</span>;
        else if (professor) return <span className="perfil professor">Professor</span>;
        else return;
    };

    const montarEstado = () => {
        const estado = ultimaEstado;
        let estilo = "frequentar";

        if (estado.titulo === "Transferido") estilo = "transferido";

        if (estado.titulo === "Anulado") estilo = "anulado";

        return (
            <span className={`estado ${estilo}`} title={estado.titulo}>
                {estado.titulo}
            </span>
        );
    };

    var permissao =
        globalContext.perfil?.nome === "Suporte" || globalContext.perfil?.nome === "Gestor" || globalContext.perfil?.nome === "SEMEI";

    return (
        <Link
            to={permissao ? `/gestao-utilizadores-detalhe/${code}` : "#"}
            disabled={!permissao}
            onClick={() => {
                globalContext.atualizarState({ cardPerfilSelecionado: perfil });
                localStorage.setItem("link_voltar", match.url);
            }}
        >
            <div className="cartao-participante">
                {montarTitulo(professor, coordenador, substituto)}
                <div className="container-img">{foto ? <img src={foto} /> : nome !== "" && <InitialsAvatar name={nome} />}</div>
                <div className="info">
                    <span className="nome">{nome.split(" ").length > 1 ? `${nome.split(" ")[0]} ${nome.split(" ").pop()}` : nome}</span>
                    <span className="numero">{numero}</span>
                </div>
                {ultimaEstado && <div className="bloco-estado">{montarEstado()}</div>}
            </div>
        </Link>
    );
};

export default withRouter(Participante);
